import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, ModalService, DropdownPicklistComponent, QueryParameter, NotificationService } from 'yt-ng-framework';
import { IzvodStavka } from './izvod-stavka';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { AbstractControl, Validators, ValidationErrors } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';
import { FakDokument } from 'src/app/fak/faktura/fak-dokument';
import { List } from 'immutable';

@Component({
  selector: 'yt-izvod-stavka-update',
  templateUrl: './izvod-stavka-update.component.html'
})
export class IzvodStavkaUpdateComponent extends BaseUpdateComponent<IzvodStavka> implements OnInit {

  defaultOrgJedID:number;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService,modalService);
  }
  @ViewChild("dropDownPickListComponent", { static: true }) dropDownPickListComponent: DropdownPicklistComponent<FakDokument>;
  parameterList: List<QueryParameter> = List([]);
  KomitentID: QueryParameter = new QueryParameter();
  prethodniKomitentID: any = null;

  ngOnInit() {
    super.ngOnInit();
    if (this.parameterList.size === 0) {
      this.parameterList = List([new QueryParameter("komitentID", -1)]);
    }

    this.baseFormGroup.get('KomitentID').valueChanges.subscribe(komitentID => {
      const prethodni = this.prethodniKomitentID;
      this.prethodniKomitentID = komitentID;

      if (prethodni !== null && prethodni !== komitentID) {
        this.baseFormGroup.patchValue({ BrojFaktureIzMinibiz: null });
      }

      if (komitentID) {
        this.parameterList = List([new QueryParameter("komitentID", komitentID)]);
        this.baseFormGroup.get("BrojFaktureIzMinibiz").enable();
        this.baseFormGroup.get("BrojFaktureNijeMinibiz").enable();
      } else {
        this.parameterList = List([new QueryParameter("komitentID", -1)]);
        this.baseFormGroup.get("BrojFaktureIzMinibiz").disable();
        this.baseFormGroup.get("BrojFaktureNijeMinibiz").disable();
      }

      this.baseFormGroup.get("BrojFaktureIzMinibiz").updateValueAndValidity();
      this.baseFormGroup.get("BrojFaktureNijeMinibiz").updateValueAndValidity();
    });
    this.addValidatorToFc('RB', Validators.required, 'required', 'IZVODSTAVKA.RB.VALIDATION.REQUIRED');
    this.addValidatorToFc('KomitentID', Validators.required, 'required', 'IZVODSTAVKA.KOMITENT.VALIDATION.REQUIRED');
    this.addValidatorToFc('OrgJedID', Validators.required, 'required', 'IZVODSTAVKA.ORGJED.VALIDATION.REQUIRED');
    this.addValidatorToFc('BrojFakture', Validators.maxLength(20), 'maxlength', 'IZVODSTAVKA.BROJFAKTURE.VALIDATION.MAXLENGTH');
    this.addValidatorToFc('Opis', Validators.maxLength(250), 'maxlength', 'IZVODSTAVKA.OPIS.VALIDATION.MAXLENGTH');

    this.baseFormGroup.setValidators(Validators.compose([
      checkDugujePotrazujeValid('Duguje', 'Potrazuje'),
      mutuallyExclusiveFaktureValidator('BrojFaktureIzMinibiz', 'BrojFaktureNijeMinibiz')
    ]));
    this.baseFormGroup.updateValueAndValidity();

    this.IDProcessed
      .subscribe(value => {
        if (value)
          if (this.Item.ID == -1 && this.Parameters != undefined) {
            this.baseFormGroup.patchValue({ RB: this.Parameters.get(0).get(0).Value });
            this.baseFormGroup.get('RB').updateValueAndValidity();
            if (this.defaultOrgJedID) {
              this.baseFormGroup.patchValue({ OrgJedID: this.defaultOrgJedID });
              this.baseFormGroup.get('OrgJedID').updateValueAndValidity();
            }
            const komitentID = this.baseFormGroup.get("KomitentID").value;
            this.prethodniKomitentID = komitentID;
            if (!komitentID) {
              this.baseFormGroup.get("BrojFaktureIzMinibiz").disable();
              this.baseFormGroup.get("BrojFaktureNijeMinibiz").disable();
            } else {
              this.baseFormGroup.get("BrojFaktureIzMinibiz").enable();
              this.baseFormGroup.get("BrojFaktureNijeMinibiz").enable();
            }
            this.baseFormGroup.get("BrojFaktureIzMinibiz").updateValueAndValidity();
            this.baseFormGroup.get("BrojFaktureNijeMinibiz").updateValueAndValidity();
          }

      });
 
  }
  TableColumnsFakDokum = [
    { name: "BrojDokumenta", label: "FAKDOKUMENT.BRDOK.SINGULAR", visible: true, canHide: false, width: "17%" },
    { name: "Datum", label: "FAKDOKUMENT.DATDOK.SINGULAR", type: "ngbDate", format: "dd.MM.yyyy", visible: true, canHide: false, width: "17%" },
    { name: "Komitent", label: "FAKDOKUMENT.KOMITENT.SINGULAR", visible: true, canHide: false, width: "17%" },
    { name: "KomitentMesto", label: "FAKDOKUMENT.KOMITENTMESTO.SINGULAR", visible: true, width: "17%", canHide: true },
    { name: "Ukupno", label: "FAKDOKUMENT.UKUPNO.SINGULAR", type: "number", visible: true, candHide: false, width: "17%" },
    { name: "VezanZaPpp", label: "FAKDOKUMENT.VEZANSAPPP.SINGULAR", visible: true, candHide: false, type: "boolean", aligment: 'center', width: "17%", tooltipName: 'VezanZaPppTooltip' },
  ];
  editMode:boolean=false;
  SaveMaster(qq){}
  Cancel(){}

    //ako postoji samo jedna organizaciona jedinica onda da bude izabrana ta jedna org.jed.
    SkupiOrgJed(items)
    {
      if (items && items.size == 1)
      {
        this.defaultOrgJedID=items.get(0).ID
      }
    };

}
function checkDugujePotrazujeValid(dugujeKey: string, porazujeKey: string) {
  return (control: AbstractControl) => {
    const _duguje: number = control.get(dugujeKey).value;
    const _potrazuje: number = control.get(porazujeKey).value;

    // if (!_duguje && !_potrazuje)
    //   return null;

    if (_duguje == 0 && _potrazuje == 0)
      return { checkDugujePotrazuje: { valid: false, message: 'IZVODSTAVKA.DUGUJEPOTRAZUJE.VALIDATION.NESMEPRAZNO' } };
  }
}

function mutuallyExclusiveFaktureValidator(minibizKey: string, notMinibizKey: string) {
  return (group: AbstractControl): ValidationErrors | null => {
    const aCtrl = group.get(minibizKey);
    const bCtrl = group.get(notMinibizKey);

    if (!aCtrl || !bCtrl) return null;

    const aVal = aCtrl.value;
    const bVal = bCtrl.value;

    // "Ima vrednost" = nije null/undefined/prazan string/0
    const hasA = !(aVal === null || aVal === undefined || aVal === '' || aVal === 0);
    const hasB = !(bVal === null || bVal === undefined || bVal === '' || bVal === 0);

    // ako su oba popunjena -> greška
    if (hasA && hasB) {
      // Obeleži i child kontrole da bi dobile crveni okvir
      aCtrl.setErrors({ ...(aCtrl.errors || {}), faktureConflict: true });
      bCtrl.setErrors({ ...(bCtrl.errors || {}), faktureConflict: true });

      return {
        faktureConflict: {
          valid: false,
          message: 'IZVODSTAVKA.VALIDATION.SAMOJEDNA'
        }
      };
    }

    // ako nije konflikt, ukloni child error ako postoji
    if (aCtrl.errors?.['faktureConflict']) {
      const { faktureConflict, ...rest } = aCtrl.errors;
      aCtrl.setErrors(Object.keys(rest).length ? rest : null);
    }
    if (bCtrl.errors?.['faktureConflict']) {
      const { faktureConflict, ...rest } = bCtrl.errors;
      bCtrl.setErrors(Object.keys(rest).length ? rest : null);
    }

    return null;
  };
}